const querystring = require('querystring');
const FormData = require('form-data');

const API_ENDPOINT = process.env.API_ENDPOINT || process.env.REACT_APP_API_ENDPOINT || '';

export default class ApiHelper {
    constructor(args) {
        this.api_path = API_ENDPOINT.replace(/\/$/, "");
    }

    post(endpoint, params = null, payload = {}) {

        // Support "params" as an optional parameter
        if (arguments.length == 2 && typeof(params) === 'object') {
            payload = params;
            params = {};
        }

        // if payload is missing or if its not an object
        if (typeof(payload) != 'object')
            payload = {}; // then its an empty object

        if (typeof(params) !== 'object')
            params = {};

        var context = this;

        return new Promise(function(resolve, reject) {

            fetch(context.api_path + endpoint + '?' + querystring.stringify(params), {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload),
                credentials: "include",
                mode: "cors"
            }).then(response => response.json()).then(response => {

                response = response && typeof(response) === 'object' ? response : {};

                var success = response.hasOwnProperty('success') ? Boolean(response.success) : false;
                var message = response.hasOwnProperty('message') && typeof(response.message) === 'string' ? response.message : '';
                var data = response.hasOwnProperty('data') ? response.data : null;

                if (success)
                    resolve(data);
                else {
                    if (data) {
                        reject({ err: message, data });
                    } else
                        reject({ err: message });
                }

            }).catch(err => {

                reject({ err: 'Unknown error: ' + err });

            });

        });

    }

    file(endpoint, params, blob, filename = '') {

        // Support "params" as an optional parameter
        if (arguments.length >= 2 && arguments[1] instanceof Blob && arguments.length < 4) {
            blob = arguments[1];
            filename = arguments?.[2] ?? '';
            params = {};
        }

        if (arguments.length >= 3 && typeof(params) !== 'object') {
            params = {};
        }

        params.file_size = blob ? blob.length || blob.size : 0;
        params.file_name = (typeof(filename) == 'string' && filename.length) ? filename : '';

        var context = this;

        return new Promise(function(resolve, reject) {

            let form = new FormData();
            if (typeof(filename) == 'string' && filename.length)
                form.append('file', blob, filename);
            else
                form.append('file', blob);

            fetch(context.api_path + endpoint + '?' + querystring.stringify(params), {
                method: 'POST',
                body: form,
                credentials: "include",
                mode: "cors"
            }).then(response => response.json()).then(response => {

                response = response && typeof(response) === 'object' ? response : {};

                var success = response.hasOwnProperty('success') ? Boolean(response.success) : false;
                var message = response.hasOwnProperty('message') && typeof(response.message) === 'string' ? response.message : '';
                var data = response.hasOwnProperty('data') ? response.data : null;

                if (success)
                    resolve(data);
                else {
                    if (data)
                        reject({ err: message, data });
                    else
                        reject({ err: message });
                }

            }).catch(err => {

                reject({ err: 'Unknown error: ' + err });

            });

        });

    }

    get(endpoint, payload = {}) {

        if (typeof(payload) != 'object')
            payload = {};

        var context = this;

        return new Promise(function(resolve, reject) {

            fetch(context.api_path + endpoint + '?' + querystring.stringify(payload), {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: "include",
                mode: "cors"
            }).then(response => response.json()).then(response => {

                response = response && typeof(response) === 'object' ? response : {};

                var success = response.hasOwnProperty('success') ? Boolean(response.success) : false;
                var message = response.hasOwnProperty('message') && typeof(response.message) === 'string' ? response.message : '';
                var data = response.hasOwnProperty('data') ? response.data : null;

                if (success)
                    resolve(data);
                else {

                    if (data)
                        reject({ err: message, data });
                    else
                        reject({ err: message });

                }

            }).catch(err => {

                reject({ err: 'Unknown error: ' + err });

            });

        });

    }

}